import { CookieAlmeSessionDataLoader } from '@alme/session-ts/CookieAlmeSessionDataLoader';
import * as Loaders from '@alme/storage-ts/CookieLoader';
const storageLoader = new Loaders.CookieLoader('almeSessionExt');
const cookieSessionLoader = new CookieAlmeSessionDataLoader(storageLoader);
const sessionDataLoader = cookieSessionLoader;
export function getAlmeSessionData() {
    let almeSessionData;
    try {
        almeSessionData = sessionDataLoader.GetAlmeSessionData();
    }
    catch (ex) {
        console.error(ex);
    }
    return almeSessionData;
}
